import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {ButtonGroup, Button} from "@mui/material";

import {useAction, useTranslate} from "../../../../../../hooks";
import {MAX_PLAYERS_IN_GAME_COUNT} from "../../../../../../constants"

const TimerButtons = ({playerId}) => {
    const {isFinish, isStart, isPause, isMaxTimeLeft} = useSelector(state => state.match);
    const {players} = useSelector(state => state.player);
    const player = players.find(player => player.id === playerId);
    const translates = useTranslate();
    const {updateTime, startGame, stopGame} = useAction();

    const playersInGameCount = players.filter(player => player.inGame).length;

    const isButtonStartDisabled = (() => {
        return player.inGame ||
            (isStart && playersInGameCount === MAX_PLAYERS_IN_GAME_COUNT) ||
            isFinish ||
            !isStart ||
            isPause
    })()

    const isButtonStopDisabled = (() => {
        return !player.inGame ||
            isFinish ||
            !isStart ||
            isPause
    })()

    useEffect(() => {
        let timer = null;
        const tick = 1000;
        const startTimerCondition = !timer && player.inGame && !isMaxTimeLeft;
        const stopTimerCondition = !player.inGame || isMaxTimeLeft;

        if(startTimerCondition) {
            timer = setInterval(() => {
                updateTime({id: playerId, time: tick})
            }, tick)
        } else if (stopTimerCondition) {
            clearInterval(timer)
        }
        return () => {
            clearInterval(timer)
        }
    }, [player.inGame, isMaxTimeLeft])

    return (
        <ButtonGroup variant="contained">
            <Button
                size="small"
                disabled={isButtonStartDisabled}
                color="success"
                variant="contained"
                onClick={() => {
                    startGame({id: playerId})
                }}
            >
                {translates['START']}
            </Button>
            <Button
                size="small"
                disabled={isButtonStopDisabled}
                color="error"
                variant="contained"
                onClick={() => {
                    stopGame({id: playerId})
                }}
            >
                {translates['STOP']}
            </Button>
        </ButtonGroup>
    )
}

export default TimerButtons